<template>
  <div>
    <fill-loader v-if='$apollo.loading' />

    <div class="rounded bg-blue-900 p-2">
      <div class="flex items-center justify-start rounded bg-blue-900">
        <img v-if='getUser.username === "anonymous"' src="/img/PBC_Icon_LatestQuestions.png" alt="" class="object-contain w-12">
        <img v-else src="/img/PBC_Meme.svg" alt="" class="object-contain w-12">
        <p class="text-white text-2xl ml-4">{{getUser.username}}</p>
      </div>

      <div class="text-gray-400">
        Member for <span class="text-white">{{fromNow(getUser.createdAt)}}</span>
      </div>
      <div class="user-stat">
        <span>{{getUser.stats.totalPosts}}</span>Posts 
      </div>
      <div class="user-stat">
        <span>{{getUser.stats.textPosts}}</span>Comments 
      </div>
      <div class="user-stat">
        <span>{{getUser.stats.totalPosts - getUser.stats.opCount}}</span>Remixes 
      </div>

    </div>

    <slot name='default' />

    <apollo-query :query='getUserPosts'
            class='flex flex-col mt-8'
            fetch-policy='cache-and-network'
             :key='username'
            :variables='{username,nextToken,size}'>
        <template v-slot="{ result: { error, data }, isLoading, query }">
            <fill-loader v-if='isLoading' />
            <posts-loading v-if='isLoading' />
            <div v-if='!isLoading' class="mx-auto w-full md:max-w-md flex-none flex flex-row py-1 topnav w-full justify-start">
              <img class="w-10 h-10 ml-1 mr-0" src='/img/PBC_logo.svg' />
              <h3 class="ml-4 text-white font-bold text-2xl">Posts</h3>
            </div>
            <pbc-posts :posts='((data||{}).getUserPosts||{}).items||[]'
                       @load-more='onLoadMore(data, query, null, $event)'
                       >
              <template #default='{}'>
                <pbc-error v-if='error' @retry='onRetry(query)' :error='error.toString()' :retry='true' message='Could not get posts for user.' />
              </template>
            </pbc-posts>

        </template>
    </apollo-query>


  </div>
</template>
<script>
import {formatDistanceToNow,parseISO} from 'date-fns';
import PostsLoading from '@ui/molecules/PostsLoading.vue';
import { uniqBy } from 'lodash';
import PbcPosts from '@/ui/organisms/PbcPosts.vue';
import {getUser,getUserPosts} from '@/gql/Queries.js';
export default {
  props: {
    username: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      getUserPosts,
      getUser: {stats:{totalPosts: 0, opCount:0, textPosts: 0 }},
      nextToken: '',
      nextNextToken: '',
      size: 10
    }
  },
  apollo: {
    getUser: {
      query: getUser,
      variables() {
        return {
          username: this.username
        }
      }
    }
  },
  components: {
    PbcPosts,
    PostsLoading
  },
  methods: {
    fromNow(date) {
      try {
        if (!date) {
          return 'who knows'
        } else {
          return formatDistanceToNow(parseISO(date));
        }
      } catch (e) {
        return 'who knows'
      }
    },
    async onRetryFetchMore(query) {
      this.loadMoreError = null;
      this.onRetry(query);
    },
    async onLoadMore(data, query, $state, highestIndexVisible) {
      const posts = ((data||{}).getUserPosts||{}).items||[];
      const lengthBefore = posts.length;

      if (highestIndexVisible < lengthBefore-1) {
        return;
      }
      const variables = {
        nextToken:this.nextNextToken,
        size:this.size,
        username: this.username
      }
      console.log('ON LOAD MORE');
      try {
        const result = await query.fetchMore({
          variables,
          updateQuery: (previousResult, { fetchMoreResult }) => {
            console.log('ON LOAD MORE UPDATED');
            const {getUserPosts} = fetchMoreResult;
            const newPosts = getUserPosts.items;
            const items = uniqBy([...previousResult.getUserPosts.items, ...newPosts], ({id}) => {
              return id;
            });
            console.log('loooooool', newPosts.length);
            this.nextNextToken = getUserPosts.nextToken;
            return {
              getUserPosts: {
                __typename: previousResult.getUserPosts.__typename,
                // Merging the tag list
                items,
                nextToken:this.nextNextToken
              },
            }
          }
        });
      } catch (e) {
        console.error('error in loadMore', e);
        this.loadMoreError = e;
      }


    }
  },
  mounted() {
    this.$ana.track({
      eventCategory: 'ui',
      eventAction: 'viewUserPosts',
      extra: {
        username: this.username
      }
    });
  }
}
</script>
<style>
.user-stat {
  @apply text-gray-400;
}
.user-stat span {
  @apply text-white text-xl mr-2;
}
</style>
